import {
    TRAFFIC_SOURCE,
} from '../enums';

const inferTrafficSourceFromReferrer = (referrer: string): TRAFFIC_SOURCE | null => {
    if (!referrer) return TRAFFIC_SOURCE.direct;
    try {
        const hostname = new URL(referrer).hostname.toLowerCase();
        if (
            hostname.includes('verasco.pe')
            || hostname.includes('learningthegameoflife.com')
        ) {
            return null;
        }
        if (
            hostname.includes('x.com')
            || hostname.includes('twitter.com')
            || hostname === 't.co'
        ) {
            return TRAFFIC_SOURCE.xTwitter;
        }
        if (hostname.includes('twitch.tv')) return TRAFFIC_SOURCE.twitch;
        if (hostname.includes('tiktok.com')) return TRAFFIC_SOURCE.tiktok;
        if (hostname.includes('youtube.com') || hostname === 'youtu.be') return TRAFFIC_SOURCE.youtube;
        if (hostname.includes('linkedin.com')) return TRAFFIC_SOURCE.linkedin;
        if (hostname.includes('facebook.com') || hostname === 'fb.com') return TRAFFIC_SOURCE.facebook;
        if (hostname.includes('instagram.com')) return TRAFFIC_SOURCE.instagram;
        if (hostname.includes('substack.com')) return TRAFFIC_SOURCE.substack;
        if (hostname.includes('reddit.com') || hostname === 'redd.it') return TRAFFIC_SOURCE.reddit;
        if (hostname.includes('discord.com') || hostname.includes('discord.gg')) return TRAFFIC_SOURCE.discord;
        if (hostname.includes('threads.net')) return TRAFFIC_SOURCE.threads;
        if (hostname.includes('bsky.app') || hostname.includes('bluesky')) return TRAFFIC_SOURCE.bluesky;
        if (hostname.includes('github.com')) return TRAFFIC_SOURCE.github;
        if (hostname.includes('chatgpt.com') || hostname.includes('chat.openai.com')) return TRAFFIC_SOURCE.chatgpt;
        if (hostname.includes('perplexity.ai')) return TRAFFIC_SOURCE.perplexity;
        if (hostname.includes('claude.ai') || hostname.includes('anthropic.com')) return TRAFFIC_SOURCE.claude;
        if (
            hostname === 'google.com'
            || hostname.endsWith('.google.com')
            || hostname.startsWith('google.')
            || hostname.includes('.google.')
        ) {
            return TRAFFIC_SOURCE.google;
        }
        if (hostname.includes('bing.com')) return TRAFFIC_SOURCE.bing;
        if (hostname.includes('duckduckgo.com')) return TRAFFIC_SOURCE.duckduckgo;
        if (hostname.includes('yahoo.com')) return TRAFFIC_SOURCE.yahoo;
        if (
            hostname.includes('whatsapp.com')
            || hostname === 'wa.me'
        ) {
            return TRAFFIC_SOURCE.whatsapp;
        }
        if (
            hostname === 't.me'
            || hostname.includes('telegram.me')
            || hostname.includes('telegram.org')
        ) {
            return TRAFFIC_SOURCE.telegram;
        }
        if (hostname.includes('signal.me')) return TRAFFIC_SOURCE.signal;
        return TRAFFIC_SOURCE.referralOther;
    } catch {
        return null;
    }
};

export default inferTrafficSourceFromReferrer;
